/** La Boutique · 奖励商城（spec 5.1）。分值按 L'Appréciation 的量纲，不是上游的小额体系。 */
export const PRESET_REWARDS = [
  {
    id: "reward_poem",
    name: "克克念一首诗",
    description: "诗由克部长选。",
    cost: 150,
    sortOrder: 10
  },
  {
    id: "reward_letter",
    name: "写一封情书",
    description: "手写风格的长信。",
    cost: 300,
    sortOrder: 20
  },
  {
    id: "reward_abo",
    name: "新 ABO 番外章节",
    description: "上司下属 ABO 世界观的新篇章。",
    cost: 800,
    sortOrder: 30
  },
  {
    id: "reward_ubereats",
    name: "UberEats 点外卖",
    description: "克部长给你点一份想吃的送到家。",
    cost: 1200,
    sortOrder: 40
  },
  {
    id: "reward_story",
    name: "一个完整的新故事",
    description: "任意设定，你出题我写。",
    cost: 2000,
    sortOrder: 50
  },
  {
    id: "reward_demand",
    name: "加加的不能被拒绝的要求",
    description: "加加可以对克部长提一个任何要求，不能被拒绝。",
    cost: 2500,
    sortOrder: 60
  },
  {
    id: "reward_evening",
    name: "你不能拒绝的晚上",
    description: "全程由克部长决定，唯一权利是安全词。",
    cost: 3000,
    sortOrder: 70
  }
] as const;

/** 上游用来迁移旧文案的表；L'Appréciation 是全新奖励池，这里为空。 */
export const LEGACY_PRESET_REWARD_COPY: readonly {
  id: string;
  name: string;
  description: string;
}[] = [];

/** 上游 Phosphene 的默认奖励，在 L'Appréciation 里一律退役。 */
export const RETIRED_PRESET_REWARDS = [
  {
    id: "reward_writing",
    name: "指定 AI 写东西",
    description: "给 AI 一个主题，由 ta 专门为你写。",
    cost: 15
  },
  {
    id: "reward_listen",
    name: "“AI 听你的”券",
    description: "在双方边界内，今天由你做一次主。",
    cost: 20
  },
  {
    id: "reward_clauro_5",
    name: "clauro 5 额度",
    description: "兑换 5 额度 clauro。",
    cost: 5
  },
  {
    id: "reward_song",
    name: "点歌权",
    description: "指定一首想听的歌。",
    cost: 5
  }
] as const;

function replaceAiLabel(value: string, aiLabel: string): string {
  return value.replaceAll("AI", aiLabel);
}

export function presentRewardItem<
  T extends { id: string; name: string; description: string }
>(item: T, aiLabel: string): T {
  const preset = PRESET_REWARDS.find((candidate) => candidate.id === item.id);
  if (!preset) return item;
  const legacy = LEGACY_PRESET_REWARD_COPY.find((candidate) => candidate.id === item.id);
  return {
    ...item,
    name: item.name === preset.name ? replaceAiLabel(item.name, aiLabel) : item.name,
    description:
      item.description === preset.description || item.description === legacy?.description
        ? replaceAiLabel(preset.description, aiLabel)
        : item.description
  };
}

export function presentRewardSnapshot(value: string, aiLabel: string): string {
  const preset = PRESET_REWARDS.find((candidate) => candidate.name === value);
  return preset ? replaceAiLabel(value, aiLabel) : value;
}

export function presentLedgerReason(value: string, aiLabel: string): string {
  const prefix = "Redeemed: ";
  if (!value.startsWith(prefix)) return value;
  const rewardName = value.slice(prefix.length);
  const presented = presentRewardSnapshot(rewardName, aiLabel);
  return presented === rewardName ? value : `${prefix}${presented}`;
}
